import React from "react";
import { Divider } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import Text from "../Text.js";

const ApprovalSwiper = ({
  item,
  setItem,
  inputDisplay,
  setInputDisplay,
  handleApproved,
  handleDeclineReason,
  approveLoading,
  preApproveLoading,
  declineLoading,
  t,
}) => {
  return (
    <div className='relative max-w-2xl mx-auto'>
      {/* Navigation Arrows */}
      <button
        type='button'
        className='swiper-button-prev absolute top-1/2 left-2 transform -translate-x-10 z-10 cursor-pointer bg-gray-400 opacity-75 text-white p-2 rounded-full shadow-md hover:bg-gray-800 transition'
        aria-label='Previous'>
        <MdChevronLeft size={24} />
      </button>
      <button
        type='button'
        className='swiper-button-next absolute top-1/2 right-1 transform translate-x-10 z-10 cursor-pointer bg-gray-400 opacity-75 text-white p-2 rounded-full shadow-md hover:bg-gray-800 transition'
        aria-label='Next'>
        <MdChevronRight size={24} />
      </button>

      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={30}
        pagination={{ clickable: true }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        className='mySwiper'>
        {/* APPROVE SLIDE */}
        <SwiperSlide>
          <div className='flex flex-col justify-center items-center p-6 bg-white shadow-md rounded-xl text-center min-h-[420px]'>
            <Text
              size='subheader'
              as='h2'>
              <CheckCircleIcon className='mr-1 w-7 h-7 inline align-middle text-green-600' />
              {t("admin:approved")}
            </Text>
            <Divider sx={{ width: "25%", my: 1 }} />
            <Text
              size='body'
              className='mb-8 max-w-md'>
              {t("admin:approvalExplainer")}
            </Text>
            <button
              onClick={() => handleApproved("approved")}
              disabled={item?.reason || approveLoading || preApproveLoading}
              className={`w-full sm:w-1/2 min-w-[200px] p-3 text-white text-lg font-semibold rounded-lg shadow-lg transition-all ${
                item?.reason || approveLoading || preApproveLoading
                  ? "bg-green-600 cursor-not-allowed opacity-60"
                  : "bg-green-600 hover:bg-green-500 cursor-pointer"
              }`}>
              {approveLoading ? "Loading..." : t("admin:approved")}
            </button>
          </div>
        </SwiperSlide>

        {/* PRE-APPROVE SLIDE */}
        <SwiperSlide>
          <div className='flex flex-col justify-center items-center p-6 bg-white shadow-md rounded-xl text-center min-h-[420px]'>
            <Text
              size='subheader'
              as='h2'>
              <ExclamationTriangleIcon className='mr-1 w-7 h-7 inline align-middle text-yellow-500' />
              {t("admin:preApproved")}
            </Text>
            <Divider sx={{ width: "25%", my: 1 }} />
            <Text
              size='body'
              className='mb-8 max-w-md'>
              {t("admin:preApprovalExplainer")}
            </Text>
            <button
              onClick={() => handleApproved("preApproved")}
              disabled={item?.reason || preApproveLoading || approveLoading}
              className={`w-full sm:w-1/2 min-w-[200px] p-3 text-white text-lg font-semibold rounded-lg shadow-lg transition-all ${
                item?.reason || preApproveLoading || approveLoading
                  ? "bg-yellow-500 cursor-not-allowed opacity-60"
                  : "bg-yellow-500 hover:bg-yellow-600 cursor-pointer"
              }`}>
              {preApproveLoading ? "Loading..." : t("admin:preApproved")}
            </button>
          </div>
        </SwiperSlide>

        {/* DECLINE SLIDE */}
        <SwiperSlide>
          <div className='flex flex-col justify-center items-center p-6 bg-white shadow-md rounded-xl text-center min-h-[420px]'>
            <Text
              size='subheader'
              as='h2'>
              <XCircleIcon className='mr-1 w-7 h-7 inline align-middle text-red-500' />
              {t("admin:declineHeader")}
            </Text>
            <Divider sx={{ width: "25%", my: 1 }} />
            <Text
              size='body'
              className='mb-8 max-w-md'>
              {t("admin:declineExplainer")}
            </Text>
            <textarea
              name='reason'
              value={item?.reason}
              className={`${inputDisplay.reason} focus:border-cromboOrange focus:ring-0 border-stone-400 border-[2px] w-full h-[150px] pl-2 pt-2 rounded-md mb-4`}
              onClick={() =>
                setInputDisplay({
                  ...inputDisplay,
                  reason: "bg-white",
                })
              }
              onChange={(e) =>
                setItem((prev) => ({ ...prev, reason: e.target.value }))
              }
            />
            <button
              onClick={handleDeclineReason}
              disabled={!item?.reason || declineLoading}
              className={`w-full sm:w-1/2 min-w-[200px] p-3 text-white text-lg font-semibold rounded-lg shadow-lg transition-all ${
                !item?.reason || declineLoading
                  ? "bg-red-500 cursor-not-allowed opacity-60"
                  : "bg-red-500 hover:bg-red-600 cursor-pointer"
              }`}>
              {declineLoading ? "Loading..." : t("admin:declined")}
            </button>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default ApprovalSwiper;
